import { ReactNode } from 'react';
import { Trans, t, type I18nLocale } from '@ardoq/i18n';
import type {
  PaginationBarLabels,
  PaginationCoreLabels,
  ShowingResultsArgs,
} from '@ardoq/pagination';

const renderShowingResults = ({
  from,
  to,
  total,
  resultTypeLabel,
}: ShowingResultsArgs): ReactNode => (
  <Trans
    i18nKey={
      resultTypeLabel
        ? 'pagination:showingResultsWithType'
        : 'pagination:showingResults'
    }
    defaults={
      resultTypeLabel
        ? 'Showing <strong>{{range}}</strong> of <strong>{{total}}</strong> {{resultTypeLabel}} results'
        : 'Showing <strong>{{range}}</strong> of <strong>{{total}}</strong> results'
    }
    values={{ range: `${from}-${to}`, total, resultTypeLabel }}
    components={{ strong: <strong /> }}
  />
);

export const getPaginationCoreLabels = (
  i18nLocale: I18nLocale
): PaginationCoreLabels => ({
  previousPageAriaLabel: t(
    i18nLocale,
    'pagination:previousPage',
    'Previous page'
  ),
  nextPageAriaLabel: t(i18nLocale, 'pagination:nextPage', 'Next page'),
});

export const getPaginationBarLabels = (
  i18nLocale: I18nLocale
): PaginationBarLabels => ({
  ...getPaginationCoreLabels(i18nLocale),
  selectPerPageAriaLabel: t(
    i18nLocale,
    'pagination:selectPerPage',
    'Select results count per page'
  ),
  perPageSuffix: t(i18nLocale, 'pagination:perPageSuffix', ' / page'),
  renderShowingResults,
});
